<script setup>
import { computed, useSlots } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
    label: {
        type: String,
        required: false,
    },
    type: {
        type: String,
        default: 'text',
    },
    required: {
        type: Boolean,
        required: false,
    },
    description: {
        type: String,
        required: false,
    },
    modelValue: {
        type: String,
        default: '',
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    labelClass: {
        type: String,
        default: '',
    },
});

const slot = useSlots();

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue']);

// Classes
const readonlyClass = computed(() => props.readonly ? '!tw-text-gray-400' : '');
</script>

<template>
    <div class="tw-flex tw-flex-col tw-justify-end">
        <label
            v-if="props.label"
            for=""
            class="!tw-text-[1.2em] tw-font-semibold"
            :class="props.labelClass"
        >
            {{ props.label }}
            <span v-if="props.required" class="tw-text-red-700">*</span>
        </label>
        <div class="tw-flex tw-items-center tw-gap-x-4 tw-py-2 tw-px-4 container-icon-input">
            <div v-if="slot.icon">
                <slot name="icon" />
            </div>
            <input
                :type="props.type"
                :required="props.required"
                :value="props.modelValue"
                @input="emit('update:modelValue', $event.target.value)"
                class="tw-outline-0 tw-border-0 tw-bg-transparent tw-w-full"
                :class="[readonlyClass]"
                :readonly="props.readonly"
            />
        </div>
        <em
            v-if="props.description" class="tw-font-semibold tw-text-[0.8em] tw-text-[#636A80] tw-mt-4"
        >{{ props.description }}</em>

        <slot name="description" />
    </div>
</template>

<style scoped>
.container-icon-input {
    /*TODO: seems like the utility class is acting weird*/
    /*@apply tw-border-b tw-border-primary tw-border-solid;*/
    border-bottom: 1px solid #FF0090;
}
</style>